(function (factory) {
  const estimator = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = estimator;
  if (typeof document !== 'undefined') estimator.start();
})(function () {
  'use strict';
  const data = window.SLDEstimatorData;
  const product = data.products.zipperedPouch;
  const controls = data.productControls.zipperedPouch;
  const sack = data.productControls.stakeSack;
  const closure = data.shared.components.sackClosure;
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  const prompt = 'Select the required options above to see the estimated weight.';
  function selections(scope) {
    const selected = Object.create(null);
    for (const element of scope.querySelectorAll('select')) {
      const label = String(element.labels && element.labels[0] && element.labels[0].textContent || '').replace(/\s+/g,' ').trim();
      if (!own(product.FIELD_LABELS, label)) continue;
      const field = product.FIELD_LABELS[label];
      selected[field] = own(selected, field) ? null : element.value;
    }
    for (const field of Object.values(product.FIELD_LABELS)) if (!own(selected, field)) selected[field] = null;
    return selected;
  }
  function estimate(choice) {
    if (!choice || typeof choice !== 'object') return null;
    for (const [field,values] of Object.entries(product.OPTIONS)) if (typeof choice[field] !== 'string' || !values.includes(choice[field])) return null;
    const fabric=product.FABRIC_KEYS[choice.Fabric], cordura=fabric.startsWith('cordura');
    const W=Number(choice.Width.slice(0,-1)), H=Number(choice.Height.slice(0,-1));
    const extra=cordura?controls.corduraAllowance:controls.otherAllowance;
    const vertical=choice.Orientation===product.OPTIONS.Orientation[0];
    const rawWidth=vertical?controls.foldFactor*W:W+extra, rawHeight=vertical?H+extra:controls.foldFactor*H;
    const zipperLength=vertical?rawHeight:rawWidth, small=choice.Zipper===product.OPTIONS.Zipper[0];
    const body=rawWidth*rawHeight*controls.densities[fabric]/1296;
    const tape=zipperLength*(small?controls.zipper3PerInch:controls.zipper5PerInch), slider=small?controls.slider3:controls.slider5;
    const tabs=controls.tabCount*(small?controls.tab3Length*controls.tab3PerInch:controls.tab5Length*(cordura?controls.tab5WebbingPerInch:controls.tab5GrosgrainPerInch));
    const finished=body+tape+slider+tabs;
    return {rawWidth,rawHeight,zipperLength,body,tape,slider,tabs,finished,grams:finished*28.3495};
  }
  function format(result) {
    return result.finished.toFixed(2) + ' oz / ' + Math.round(result.grams) + ' g';
  }
  function start() {
    const root = document.querySelector('[data-sld-zippered-pouch-estimator]');
    if (!root) return;
    const scope = root.closest('product-info') || document;
    const results = root.querySelector('[data-sld-estimator-results]');
    const message = root.querySelector('[data-sld-estimator-message]');
    const weight = root.querySelector('[data-sld-weight-zippered-pouch]');
    function text(element,value) { if (element && element.textContent !== value) element.textContent = value; }
    function calculate() {
      const result = estimate(selections(scope));
      if (results) results.hidden = !result || !!result.manual;
      text(message,result && result.manual ? 'Custom colors require a manual weight estimate. Please contact me before ordering.' : result ? '' : prompt);
      text(weight,result && !result.manual ? format(result) : '');
    }
    let timer;
    const queue = () => { clearTimeout(timer); timer = setTimeout(calculate,75); };
    scope.addEventListener('change',queue,true);
    scope.addEventListener('input',queue,true);
    new MutationObserver(mutations => {
      if (mutations.some(mutation => !root.contains(mutation.target))) queue();
    }).observe(scope,{subtree:true,childList:true,attributes:true,attributeFilter:['value','checked','selected']});
    calculate();
  }
  return {estimate,selections,format,start};
});

